import { render, staticRenderFns } from "./LayoutPublic.vue?vue&type=template&id=16d3d721&scoped=true&lang=html"
import script from "./LayoutPublic.vue?vue&type=script&lang=js"
export * from "./LayoutPublic.vue?vue&type=script&lang=js"
import style0 from "./LayoutPublic.vue?vue&type=style&index=0&id=16d3d721&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d3d721",
  null
  
)

export default component.exports